import type {TeasState} from '../../types/TeasState';

export const selectGeneralSettings = (state: TeasState) => state.generalSettings;
